import React from "react";
import { TouchableOpacity, View } from "react-native";
import { StyleSheet } from "react-native";
import { Button as _Button } from "src/common/assets/mixins";
import { StoreItemType } from "src/common/types/response/stores";
import Text from "./text";
import { getImageUrl } from "libs/utils/image";
import { SCREEN_HEIGHT, TABLET_PC } from "../libs/utils/constants";
import useOrientation from "../libs/hooks/useOrientation";
import { getScreenHeightWidth } from "src/customer/utils/storeItemUtils";
import GreyScaleImage from "./greyscaleImage";

const StoreItem = ({
  data,
  style,
  lastItemStyle,
  oddItemStyle,
  evenItemStyle,
  onPress,
}: {
  data: StoreItemType;
  style?: object;
  lastItemStyle?: object;
  oddItemStyle?: object;
  evenItemStyle?: object;
  onPress?: (id: string) => void;
}) => {
  const orientation = useOrientation();
  const image = data?.images?.length && data?.images[0];
  const nonMobileStyle = TABLET_PC;
  const { height: screenHeight } = getScreenHeightWidth(orientation);

  const itemHeight = screenHeight * 0.25;
  return (
    <TouchableOpacity
      style={[
        styles.root,
        style,
        lastItemStyle,
        oddItemStyle,
        evenItemStyle,
        nonMobileStyle && {
          height: itemHeight,
        },
      ]}
      onPress={() => onPress(data._id)}
      activeOpacity={0.8}
    >
      {!data?.meta && (
        <>
          <GreyScaleImage
            source={{ uri: getImageUrl(image) }}
            style={styles.image}
            resizeMode="cover"
            greyscale={!(data.is_active && data.is_serving)}
          />
          <View style={styles.imageOverlay}>
            <Text style={styles.name}>{data?.name}</Text>
            <Text style={styles.city}>{data?.address?.city}</Text>
          </View>
        </>
      )}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  root: {
    height: 174,
    flex: 1,
    borderRadius: 15,
    backgroundColor: "#fff",
    overflow: "hidden",
    maxWidth: SCREEN_HEIGHT / 2,
  },
  image: {
    height: "100%",
  },
  imageOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    justifyContent: "flex-end",
    padding: 10,
  },
  name: {
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: 16,
    lineHeight: 20,
    color: "#FFFFFF",
  },
  city: {
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: 12,
    lineHeight: 15,
    color: "#FFFFFF",
  },
});

export default StoreItem;
